(function () {
  'use strict';
  var PREFERS_REDUCED_MOTION = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)').matches : false;

  function initFadeReveal() {
    var targets = document.querySelectorAll('[data-shos-fade]');
    if (!targets.length) return;
    if (PREFERS_REDUCED_MOTION || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    targets.forEach(function (el) { observer.observe(el); });
  }

  function initScrollIndicators() {
    var indicators = document.querySelectorAll('[data-shos-scroll-target]');
    indicators.forEach(function (indicator) {
      indicator.addEventListener('click', function () {
        var targetSelector = indicator.getAttribute('data-shos-scroll-target');
        var targetEl = targetSelector ? document.querySelector(targetSelector) : (indicator.closest('.shos-block') && indicator.closest('.shos-block').nextElementSibling);
        if (targetEl && targetEl.scrollIntoView) {
          targetEl.scrollIntoView({ behavior: PREFERS_REDUCED_MOTION ? 'auto' : 'smooth', block: 'start' });
        }
      });
      indicator.style.cursor = 'pointer';
    });
  }

  function initBackgroundVideo() {
    var videos = document.querySelectorAll('[data-shos-bg-video]');
    videos.forEach(function (video) {
      if (PREFERS_REDUCED_MOTION) { video.pause(); video.removeAttribute('autoplay'); return; }
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') { playPromise.catch(function () {}); }
    });
  }

  function initMotionToggle() {
    var motionDisabledBlocks = document.querySelectorAll('[data-shos-motion="false"]');
    motionDisabledBlocks.forEach(function (block) { block.classList.add('shos-no-motion'); });
  }

  function init() {
    initMotionToggle();
    initFadeReveal();
    initScrollIndicators();
    initBackgroundVideo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  window.SHOS = window.SHOS || {};
  window.SHOS.reinit = init;
})();
